import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionFaqModule } from '@studiobuki/web-core/lib/section-faq';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { FaqPageComponent } from './faq-page.component';
import { SectionFooterBannersModule } from '../../shared/section-footer-banners/section-footer-banners.module';

@NgModule({
  declarations: [FaqPageComponent],
  imports: [
    CommonModule,
    SectionHeaderGapModule,
    SectionFaqModule,
    SectionFooterBannersModule,
  ],
})
export class FaqPageModule {}
